export default __webpack_public_path__ + "static/logo-9c58493dd3298ec98414742bd6ecaf12.svg";